export default {
	nameFieldMissing: "Meeting must have a name.",
	linkFieldMissing: "Virtual meeting link is required.",
	invalidLinkField: "Must be a Zoom, Microsoft Teams, or Google Meet link.",
	frequencyFieldMissing: "Meeting frequency is required.",
	invalidFrequencyField: "Meeting frequency is invalid.",
	daysFieldMissing: "Meeting day is required.",
	invalidDaysField: "Meeting day is invalid.",
	timeFieldMissing: "Meeting time is required.",
	invalidTimeField: "Meeting time is invalid.",
	meridiemFieldMissing: "Meeting meridiem is required.",
	invalidMeridiemField: "Meeting meridiem is invalid.",
	timezoneFieldMissing: "Meeting timezone is required.",
	invalidTimezoneField: "Meeting timezone is invalid.",
	startDateFieldMissing: "Meeting start date is required.",
	incorrectStartDateDays: "Start date must be on {days}",
	incorrectStartDateDay: "Start date must be on the {nth} {day}",
	invalidDayOffsetField: "Day position is invalid.",

	sundayLongLabel: "Sunday",
	mondayLongLabel: "Monday",
	tuesdayLongLabel: "Tuesday",
	wednesdayLongLabel: "Wednesday",
	thursdayLongLabel: "Thursday",
	fridayLongLabel: "Friday",
	saturdayLongLabel: "Saturday",

	offset1Label: "1st",
	offset2Label: "2nd",
	offset3Label: "3rd",
	offset4Label: "4th",
};
